"use strict";
exports.__esModule = true;
exports.RelatedEntityType = void 0;
var RelatedEntityType;
(function (RelatedEntityType) {
    RelatedEntityType["Position"] = "POSITION";
    RelatedEntityType["Balance"] = "BALANCE";
    RelatedEntityType["Transaction"] = "TRANSACTION";
    RelatedEntityType["Price"] = "PRICE";
})(RelatedEntityType = exports.RelatedEntityType || (exports.RelatedEntityType = {}));
